import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';
import { requireWorkspace } from '@/router/require-workspace';
import JobsPage from '@/features/jobs/jobs-list/JobsPage';
import { JobsSearchSchema, type JobsSearch } from '@/features/jobs/jobs-list/jobs-search.schema';
import { jobsQueryOptions } from '@/features/jobs/jobs-list/jobs-query';

export const jobsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/vagas',
  // Bookmarkable URL state — falls back to defaults on malformed values.
  validateSearch: (raw) => JobsSearchSchema.parse(raw),
  // App Consultor: require a selected company/área de trabalho (EU-374) —
  // bounce to the Home + toast when none is present.
  beforeLoad: requireWorkspace,
  // Non-blocking prefetch — kicks off the jobs fetch as the route loads
  // but does NOT await it. The container's `useQuery` (with
  // `placeholderData: keepPreviousData`) then either hits the warm cache or
  // shows its own cold-load fallback.
  loaderDeps: ({ search }) => search as JobsSearch,
  loader: ({ context, deps }) => {
    // DEV-315 AC-4 — sem programa selecionado não há busca de vagas, nem aqui.
    if (!deps.programId) return;
    void context.query.prefetchQuery(jobsQueryOptions(deps));
  },
  component: JobsPage,
});
